import React from 'react';
import { cn } from '../../utils/cn';
import type { TabType } from '../../hooks/useGroupDetails';

interface GroupTabsProps {
    activeTab: TabType;
    onTabChange: (tab: TabType) => void;
}

export const GroupTabs: React.FC<GroupTabsProps> = ({ activeTab, onTabChange }) => {
    return (
        <div className="flex gap-1 rounded-xl bg-bg-card-alt p-1">
            {(['expenses', 'tasks', 'members'] as TabType[]).map((tab) => (
                <button
                    key={tab}
                    onClick={() => { onTabChange(tab); }}
                    className={cn(
                        "flex-1 rounded-lg py-2 text-xs font-bold transition-all capitalize",
                        activeTab === tab ? "bg-bg-card text-primary-600 shadow-sm" : "text-text-muted hover:text-text-body"
                    )}
                >
                    {tab}
                </button>
            ))}
        </div>
    );
};
